import { IconSvg, IconSvgProps } from "./icon"

export default function ChevronUp(props: IconSvgProps) {
  return (
    <IconSvg {...props} strokeModifier={1.125}>
      <path d="m21 16-7.907-7.907a.618.618 0 0 0-.9 0L4.286 16" />
    </IconSvg>
  )
}
